/**
 * Recycle Google Map
 * 
 * It is impossible to destroy a Google Maps, it must
 * be reused (recycle). This is a controller to retreive
 * am existing "free" map, or create a new one if none
 * are available.
 */

import { Loader } from "google-maps"

class GoogleMapsRecycler {

    constructor() {
        this.record = {}
    }

    /**
     * Attach an exist map to the an HTMLElement, if available,
     * else create a new map.
     * 
     * @param {any} element
     * @param {any} apiKey
     * @param {any} options
     */
    async attachMap(element, apiKey) {
        
        // Create a record for the apiKey if none exist

        if (!this.record[apiKey]) {
            const loader = new Loader(apiKey, {});
            const google = await loader.load();
            this.record[apiKey] = {
                loader,
                google,
                maps: []
            }
        }

        // Check for a "free" map

        const mapObj = this.record[apiKey].maps.find(x => x.node.parentNode === null)
        
        if (mapObj && mapObj.map) {
            element.append(mapObj.node)
            return mapObj.map

        }

        // None free, create a new map

        const node = document.createElement('div')
        node.style.position = "absolute"
        node.style.top = "0"
        node.style.left = "0"
        node.style.height = "100%"
        node.style.width = "100%"

        const map = new this.record[apiKey].google.maps.Map(node, {
            maxZoom: 15
        })

        this.record[apiKey].maps.push({ node, map })

        element.append(node)
        return map
    }

    /**
     * Detach a map, alowing it to be reused (recycle)
     * 
     * VERY IMPORTANT
     * Clean up the map before detaching. This method won't
     * remove any options, addition (ex. marker) fromt he map.
     * 
     * @param {any} map
     */
    detachMap(map) {
        for (const [key, apiRecord] of Object.entries(this.record)) {

            const obj = apiRecord.maps.find(x => x.map === map)

            if (!obj) continue

            // Detach from DOM
            if (obj.node.parentNode) {
                obj.node.parentNode.removeChild(obj.node)
            }

            break
        }
    }

}

export default new GoogleMapsRecycler()